import { newsletterSubscribe } from "./api";
import { pushEvent } from "./analytics";
import { showToast } from './toast';

export function initFooter() {
    window.addEventListener('DOMContentLoaded', () => {
        const component = document.querySelector('.cmp-footer__newsletter');
        const form = component.querySelector('form');
        
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const email = form.querySelector('input[type="email"]').value;
            newsletterSubscribe(email)
                .then(() => {
                    component.classList.add('cmp-footer__newsletter--success');
                    
                    // GTM: Track successful newsletter subscription
                    pushEvent({
                        'event': 'formSubmission',
                        'formID': 'newsletter'
                    });
                })
                .catch(e => {
                    console.error('error signing up for newsletter', e);
                    showToast('Sorry, there was a problem adding your email address', 'error');
                });
        });
    })
}